import gsap from "gsap";
import Swiper from "swiper";
class Slider {
    constructor(elementsClass, autoplay, spaceBetween=0) {
      this.autoplayTime = autoplay;
      this.elementClass = elementsClass;
      this.spaceBetween = spaceBetween;
      this.init();

    }
  
    init() {
      let self = this;
      self.autoplayLocked = false;
      const sliders = document.querySelectorAll(this.elementClass);
      if (sliders) {
        const autoplayTime = this.autoplayTime;
        if (document.querySelector('.swiper-pagination-bullet .bullet') &&  window.innerWidth > 768 ) {
          gsap.set('.swiper-pagination-bullet .bullet', {width: 0})
        }
        gsap.defaults({ overwrite: true });
        
        sliders.forEach(slider => {
          let autoplayInitialized = false;
          const parentWrapper = slider.closest('.swiper-container')
          let autoplayInit = window.innerWidth > 768 ?  { delay: autoplayTime } : false;
          // let currentEffect = window.innerWidth > 768 ? 'fade' : 'cube';
          let currentSwiper = new Swiper (
              slider, {
                    simulateTouch: true,
                    autoplay: autoplayInit,
                    spaceBetween: this.spaceBetween,
                    watchSlidesProgress: false,
                    keyboard: {
                      enabled: true,
                      onlyInViewport: true,
                    },
                    // effect: currentEffect,
                    // cubeEffect: {
                    //   slideShadows: false,
                    //   shadowScale: false,
                    //   shadowOffset: 0,
                    // },
                    loop: true,
                    lazy:  {
                      loadPrevNext: true,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: false,
                        renderBullet: function (index, className) {
                          return '<span class="' + className + ' cursor-pointer"><span class="flex bullet-wrapper"><span class="bullet" data-index="' + index + '">' + "</span></span></span>";
                        },
                    },
                    on: {

                      init: function() {
                        let bullets = slider.querySelectorAll('.swiper-pagination-bullet');
                        if (bullets) {
                          bullets.forEach(bullet => {
                            bullet.addEventListener('click', () => {
                              slider.swiper.slideTo(bullet.querySelector('.bullet').getAttribute('data-index'))
                            })
                          })
                        }
                      },
                      reachEnd: function() {
                        if (parentWrapper.querySelector('.swiper-pagination-bullet .bullet') ){
                          gsap.set('.swiper-pagination-bullet .bullet', {width: 0})
                          parentWrapper.querySelectorAll('.swiper-pagination-bullet .bullet').forEach(bullet => {
                            bullet.classList.remove('visited');
                          })
                        }
                      },
                      slideChangeTransitionStart: function(swiper) {
                        if (window.innerWidth > 768) {
                          swiper.autoplay.stop();
                          self.autoplayLocked = true;
                        }
                        parentWrapper.querySelectorAll('.bullet').forEach(bullet => {
                          bullet.classList.remove('visited');
                          gsap.set(bullet, {width: 0})
                        })

                        let currentBullet = parentWrapper.querySelector('.swiper-pagination-bullet-active')
                        if (currentBullet) {
                          let currentIndex = currentBullet.querySelector('.bullet').getAttribute('data-index')
                          parentWrapper.querySelectorAll('.swiper-pagination-bullet .bullet').forEach(bullet => {
                            let bulletIndex = bullet.getAttribute('data-index');

                            if (bulletIndex < currentIndex) {
                              bullet.classList.add('visited')
                            }
                            if (bulletIndex > currentIndex) {
                              bullet.classList.remove('visited')
                            }
                          })
                        }
                        if (window.innerWidth > 768) {
                          swiper.autoplay.start();
                          self.autoplayLocked = false;
                        }
                      },
                      slideChangeTransitionEnd: function () {
                        if (window.innerWidth > 768) {
                          if (parentWrapper.querySelector('.swiper-pagination-bullet-active .bullet')) { 
                            if ( self.autoplayLocked == false &&  window.innerWidth > 768) {  
                              gsap.fromTo(parentWrapper.querySelector('.swiper-pagination-bullet-active .bullet'), {width: 0},{width: '100%', duration: autoplayTime/1000, ease: "none"})
                            }
                          }
                        }
                    
                        let currentSlide = parentWrapper.querySelector('.swiper-slide-active');
                        if (currentSlide) {
                          parentWrapper.querySelectorAll('.swiper-slide').forEach(slide => {
                              if (slide.querySelector('video')) {
                                  slide.querySelector('video').pause();
                                  slide.querySelector('video').classList.remove('js-autoplay');
                              }
                          });
                          if (currentSlide.querySelector('.js-to-play')) {
                            currentSlide.querySelector('.js-to-play').play();
                            currentSlide.querySelector('.js-to-play').classList.add('js-autoplay');
                          }
                        }
                      }
                    },
                }
            );

            currentSwiper.autoplay.stop();
            autoplayInitialized = true;

            parentWrapper.onmouseenter = function(e) { 
              if (autoplayInitialized &&  window.innerWidth > 768) {
                if (parentWrapper.querySelector('.swiper-pagination-bullet-active .bullet')) {
                  gsap.fromTo(parentWrapper.querySelector('.swiper-pagination-bullet-active .bullet'), { width: 0 },{width: '100%', duration: autoplayTime/1000, ease: "none"})
                }
                currentSwiper.autoplay.start();
              }
            }
            
            parentWrapper.onmouseleave = function() { 
              if (window.innerWidth > 768) {

                currentSwiper.autoplay.stop();
                if (document.querySelector('.swiper-pagination-bullet-active .bullet')) {  
                  gsap.to('.swiper-pagination-bullet-active .bullet', {width: 0, duration: 0.1, ease: "none"})
                }
              }
            }
        });
      }
    }
  }
  
  export default Slider;
